export default __webpack_public_path__ + "static/media/src_jquery_desktop_5.d18525e6.jpg";